import { Card, Text } from "@overmap-ai/blocks"
import { type Asset, type Stored, UNLABELLED_ASSET_LABEL } from "@overmap-ai/common"
import { selectUserById } from "@overmap-ai/core"
import { memo } from "react"

import { AssetTimelineItemType } from "../../enums/assets"
import { assetTimelineItemTypeData } from "../../mappings/assets"
import { useAppSelector } from "../../store"
import { formatCompactDate } from "../../utils/date"
import { getUserDisplayLabel } from "../../utils/users"
import { AssetTypeIcon } from "../Icons/AssetTypeIcon"
import { AssetIndexLabel } from "../IndexLabels/AssetIndexLabel"
import { TimelineIconRail } from "../TimelineIconRail/TimelineIconRail"
import type { AssetTimelineSize } from "./typings"

interface CreatedAssetTimelineItemProps {
	asset: Stored<Asset>
	size: AssetTimelineSize
}

export const CreatedAssetTimelineItem = memo<CreatedAssetTimelineItemProps>((props) => {
	const { asset, size } = props

	const createdBy = useAppSelector(selectUserById(asset.created_by ?? -1))

	const { icon } = assetTimelineItemTypeData[AssetTimelineItemType.CREATED]

	return (
		<div className="flex h-max w-full gap-4">
			<TimelineIconRail icon={icon} size={size} />
			<Card className="flex min-w-0 grow flex-col gap-1" size={size}>
				<Text size={size} accentColor="base">
					<Text highContrast>{getUserDisplayLabel(createdBy)}</Text>
					&nbsp;created asset
					<Text accentColor="base">&nbsp;&#8226;&nbsp;{formatCompactDate(asset.submitted_at)}</Text>
				</Text>
				<Text accentColor="base" className="min-w-0 truncate" size={size}>
					<AssetTypeIcon assetTypeId={asset.asset_type} className="align-sub" />
					&nbsp;
					<AssetIndexLabel assetId={asset.uuid} highContrast />
					&nbsp;
					<Text accentColor="base">{asset.label || UNLABELLED_ASSET_LABEL}</Text>
				</Text>
			</Card>
		</div>
	)
})
CreatedAssetTimelineItem.displayName = "CreatedAssetTimelineItem"
